// src/lib/supabaseClient.js
import { createSupabaseClient } from '@astra/core/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const SUPABASE_GLOBAL_KEY = '__astraXR_supabaseClient';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase configuration. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file (see .env.example).'
  );
}

const createSupabase = () => {
  // In development, disable auto-detection to handle OAuth manually
  // This avoids issues with localhost SSL certificates and HMR
  const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost'
  
  const client = createSupabaseClient({
    url: supabaseUrl,
    anonKey: supabaseAnonKey,
    detectSessionInUrl: !isDevelopment, // Disable in dev only
    storageKey: 'supabase.auth.token',
    clientInfo: 'supabase-js-web',
  });
  
  console.log('[Supabase Client] Initialized:', {
    isDevelopment,
    detectSessionInUrl: !isDevelopment,
    flowType: 'pkce'
  });

  return client;
};

let supabaseInstance;

if (typeof globalThis !== 'undefined') {
  if (!globalThis[SUPABASE_GLOBAL_KEY]) {
    globalThis[SUPABASE_GLOBAL_KEY] = createSupabase();
  }
  supabaseInstance = globalThis[SUPABASE_GLOBAL_KEY];
} else {
  supabaseInstance = createSupabase();
}

export const supabase = supabaseInstance;

export default supabase;
